import { render, staticRenderFns } from "./CompItemStatusGrid.vue?vue&type=template&id=198b5f0a"
import script from "./CompItemStatusGrid.vue?vue&type=script&lang=js"
export * from "./CompItemStatusGrid.vue?vue&type=script&lang=js"
import style0 from "./CompItemStatusGrid.vue?vue&type=style&index=0&id=198b5f0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports